<template>
    <div class="vue-main-wrapper">
        <div class="app-container">
          <div class="keep-dom-rendered-apps-container"
               v-for="keepAliveDomApp in keepDOMRenderedApps"
               v-show="selectedApp === keepAliveDomApp">
            <component :is="keepAliveDomApp"></component>
          </div>
          <component v-if="!keepDOMRenderedApps.includes(selectedApp)" :is="selectedApp"></component>
        </div>
    </div>
</template>

<script>
    import { getApplications } from './../apps-loader';
    const apps = getApplications();

    export default {
        name: 'vue-hybrid-layout-manager',
        data: function() {
            return {
                apps: [],
                keepDOMRenderedApps: [],
                selectedApp:'',
            };
        },
        created: function() {
            // store for future use...!!!
            window.MainViewControllerBody = window.document.getElementsByClassName('LP_mainwrapping_container')[0];
            const validApps = this.$store.getters['environment/validApps'];
            Object.values(apps).filter((app) => {
                return app && validApps.indexOf(app.config.routePrefix) > -1;
            }).forEach(app => {
                if(app.keepDOMRendered){
                  this.keepDOMRenderedApps.push(app.config.routePrefix);
                }
                else {
                  this.apps.push(app.config.routePrefix)
                }
            });
        },
        mounted: function() {
            // add app routes to store. (for the persona switcher)
            // this.calculateActiveViewContainer()
        },
        methods:{
            calculateActiveViewContainer: function(){
                const workAreaWrapper = document.getElementsByClassName('main-wrapper');
                const vueWorkAreaWrapper = document.getElementsByClassName('vue-main-wrapper');
                const reactWorkAreaWrappers = document.querySelectorAll('[class^="react-main-wrapper"]');
                if(workAreaWrapper.length === 0){
                    return;
                }
                if(!this.$route || !this.$route.meta) {
                  return;
                }
                $('.startLoaderImg').remove();
                if (this.$route.meta.marrionetteModule) {
                    workAreaWrapper[0].style.display = "block";
                    reactWorkAreaWrappers.forEach((el) => el.style.display = 'none');
                    vueWorkAreaWrapper[0].style.display = "none";
                    window.LE.context.set('activeVueApp', undefined);
                }
                else if (this.$route.meta.react){
                  const reactApp = window.reactElements.find(({appId}) => this.$route.path.includes(appId));
                  const selectedApp = document.querySelector(`.react-main-wrapper-${reactApp.appId}`);
                  workAreaWrapper[0].style.display = "none";
                  vueWorkAreaWrapper[0].style.display = "none";
                  selectedApp.style.display = 'block';
                  window.LE.context.set('activeReactApp', { applicationName: reactApp.appId, pageName: this.$route.name });
                  window.LE.context.set('activeVueApp', undefined);
                }
                else{
                    this.selectedApp = this.$route.path.split('/').filter(function(e){return e})[0];
                    workAreaWrapper[0].style.display = "none";
                    reactWorkAreaWrappers.forEach((el) => el.style.display = 'none');
                    vueWorkAreaWrapper[0].style.display = "block";
                    const applicationName = this.$route.path.split('/').filter(b => b).shift();
                    const pageName = this.$route.name;
                    const pageMeta = this.$route.meta;
                    window.LE.context.set('activeVueApp', { applicationName, pageName, pageMeta });
                    window.LE.navigator.vent.trigger("module:active", {moduleName: applicationName});
                }
            },
        },
        watch: {
            $route: function () {
                this.calculateActiveViewContainer();
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    @import "../../assets/scss/global";
    .vue-main-wrapper{
        top: $user-bar-height;
        bottom: 0;
        right: 0;
        left: $user-bar-width;
         position: absolute;
        .app-container {
          height: 100%;
          position: relative;
          .keep-dom-rendered-apps-container {
            height: 100%;
            position: relative;
          }
        }
    }
</style>
